<template lang="pug">
    include ContentPage.pug
</template>

<script>

import ContentPage from './ContentPage'

import EventForm from '@/components/EventManager/Form'
import EventCalendar from '@/components/EventManager/Calendar'

export default {
    name: 'EventPage',
    extends: ContentPage,
    components: {
        EventForm,
        EventCalendar,
    },
    computed: {
        mainSections() {
            return this.sections.filter(section => {
                return section.area === 'main'
                    && (section.key === 'heading' || section.key === 'post' || section.key === 'events')
            })
        },
        additionalSections() {
            return this.sections.filter(section => {
                return section.area === 'main' && section.key === 'events'
            })
        },
    },
}

</script>

<style lang="sass" scoped>

    @import '~@/assets/sass/variables';
    @import "~bulma/sass/utilities/mixins";

    .slide-container
        background: $black
        color: $white
        button.close-slide-container
            display: none
            +desktop
                display: none
        .event-calendar

    .column.right
        // .section.events
        //     display: none
        //     +desktop
        //         display: initial
        footer
            color: $white
            #footer-menu
                a,
                li:before
                    text-shadow: 0px 1px 5px transparentize($white, 0.7), 0px 1px 2px transparentize($white, 0.5)
</style>
